/* Metcos Content Protection — mdj-protect.js
 * Deters casual saving of product images and videos.
 * Driven by #MdjProtectConfig, printed by sections/mdj-protect.liquid.
 * Nothing here can stop a screenshot or a direct CDN URL — the baked-in watermark does that.
 */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  var cfgEl = document.getElementById('MdjProtectConfig');
  if (!cfgEl) return;

  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }
  if (!cfg || !cfg.enabled) return;

  var MEDIA_SEL = 'img, video, picture, svg image, .mdj-shield, .mdj-wm';
  var EDITABLE_SEL = 'input, textarea, select, [contenteditable="true"], [contenteditable=""]';

  function inScope() {
    if (cfg.scope === 'all') return true;
    var t = (cfg.template || '').split('.')[0];
    if (cfg.scope === 'product') return t === 'product';
    if (cfg.scope === 'product_collection') return t === 'product' || t === 'collection';
    return true;
  }
  if (!inScope()) return;

  document.documentElement.classList.add('mdj-protected');
  if (cfg.contextmenu_scope === 'page') {
    document.documentElement.classList.add('mdj-protected-page');
  }

  /* ------------------------------------------------------------------- toast */

  var toastEl = null;
  var toastTimer = null;

  function toast() {
    if (!cfg.show_toast || !cfg.toast_text) return;
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'mdj-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = cfg.toast_text;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2200);
  }

  /* -------------------------------------------------------------- right click */

  function shouldBlock(t) {
    if (!t || !t.closest) return true;
    if (t.closest(EDITABLE_SEL)) return false;
    if (cfg.contextmenu_scope === 'page') return true;
    return !!t.closest(MEDIA_SEL);
  }

  if (cfg.block_contextmenu) {
    document.addEventListener(
      'contextmenu',
      function (e) {
        if (shouldBlock(e.target)) {
          e.preventDefault();
          e.stopPropagation();
          toast();
        }
      },
      { capture: true }
    );

    // Some Android builds fire only the legacy handler.
    document.oncontextmenu = function (e) {
      return !shouldBlock(e && e.target);
    };
  }

  /* ------------------------------------------------- long press (iOS/Android) */

  if (cfg.block_longpress) {
    var lpTimer = null;

    document.addEventListener(
      'touchstart',
      function (e) {
        if (!shouldBlock(e.target)) return;
        clearTimeout(lpTimer);
        lpTimer = setTimeout(function () {
          // Clearing the selection is what stops the iOS save sheet in the
          // browsers that ignore -webkit-touch-callout.
          if (window.getSelection) {
            var sel = window.getSelection();
            if (sel && sel.removeAllRanges) sel.removeAllRanges();
          }
          toast();
        }, 450);
      },
      { capture: true, passive: true }
    );

    ['touchend', 'touchmove', 'touchcancel'].forEach(function (evt) {
      document.addEventListener(
        evt,
        function () {
          clearTimeout(lpTimer);
        },
        { capture: true, passive: true }
      );
    });

    // iOS Safari fires this instead of contextmenu on a long press over an image.
    document.addEventListener(
      'selectstart',
      function (e) {
        var t = e.target;
        if (t && t.closest && t.closest(EDITABLE_SEL)) return;
        if (t && t.closest && t.closest(MEDIA_SEL)) e.preventDefault();
      },
      { capture: true }
    );
  }

  /* ---------------------------------------------------------------- drag away */

  if (cfg.block_drag) {
    document.addEventListener(
      'dragstart',
      function (e) {
        var t = e.target;
        if (t && t.closest && t.closest(MEDIA_SEL)) e.preventDefault();
      },
      { capture: true }
    );
  }

  /* ------------------------------------------------------------ keyboard saves */

  document.addEventListener(
    'keydown',
    function (e) {
      var k = (e.key || '').toLowerCase();
      var mod = e.ctrlKey || e.metaKey;

      if (cfg.block_save_shortcut && mod && !e.shiftKey && !e.altKey && k === 's') {
        e.preventDefault();
        toast();
        return;
      }

      if (!cfg.block_devtools_shortcuts) return;

      // Cosmetic only — the browser menu still opens devtools.
      if (mod && !e.shiftKey && k === 'u') {
        e.preventDefault();
        return;
      }
      if (k === 'f12') {
        e.preventDefault();
        return;
      }
      if (mod && e.shiftKey && (k === 'i' || k === 'j' || k === 'c')) {
        e.preventDefault();
      }
    },
    { capture: true }
  );

  /* ------------------------------------------------------------------- videos */

  function hardenVideo(v) {
    if (!v || v.__mdjDone) return;
    v.__mdjDone = true;
    v.setAttribute('controlsList', 'nodownload noremoteplayback noplaybackrate');
    v.setAttribute('disablePictureInPicture', '');
    v.setAttribute('disableRemotePlayback', '');
    v.disablePictureInPicture = true;
  }

  /* ------------------------------------------------------------------- shield */

  var SHIELD_HOSTS = [
    '.product__media',
    '.product-media-container',
    '.media--transparent',
    '.mdj-video-player__stage'
  ].join(',');

  function shield(host) {
    if (!host || host.__mdjShield) return;
    if (!host.querySelector('img, video')) return;
    host.__mdjShield = true;

    var cs = window.getComputedStyle(host);
    if (cs.position === 'static') host.style.position = 'relative';

    var s = document.createElement('div');
    s.className = 'mdj-shield';
    s.setAttribute('aria-hidden', 'true');

    // Pass genuine clicks through so zoom, lightbox and the video player still work.
    s.addEventListener('click', function (e) {
      s.style.pointerEvents = 'none';
      var under = document.elementFromPoint(e.clientX, e.clientY);
      s.style.pointerEvents = '';
      if (under && under !== s) {
        var clickable = under.closest('button, a, [role="button"], video, .product__modal-opener');
        (clickable || under).click();
      }
    });

    host.appendChild(s);
  }

  /* --------------------------------------------------------------- watermark */

  function wmBackground() {
    var text = (cfg.watermark_text || '').trim();
    if (!text) return '';
    var size = parseInt(cfg.watermark_size, 10) || 16;
    var tile = Math.max(160, text.length * size * 0.75);
    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="' + tile + '" height="' + tile + '">' +
      '<text x="50%" y="50%" fill="' + (cfg.watermark_color || '#ffffff') + '" ' +
      'font-family="Helvetica,Arial,sans-serif" font-size="' + size + '" ' +
      'text-anchor="middle" dominant-baseline="middle" ' +
      'transform="rotate(-30 ' + tile / 2 + ' ' + tile / 2 + ')">' +
      text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;') +
      '</text></svg>';
    return 'url("data:image/svg+xml;utf8,' + encodeURIComponent(svg) + '")';
  }

  function watermark(host) {
    if (!host || host.__mdjWm) return;
    if (!host.querySelector('img, video')) return;
    host.__mdjWm = true;

    var cs = window.getComputedStyle(host);
    if (cs.position === 'static') host.style.position = 'relative';

    var w = document.createElement('div');
    w.className = 'mdj-wm mdj-wm--' + (cfg.watermark_style || 'corner');
    w.setAttribute('aria-hidden', 'true');
    w.style.opacity = (parseInt(cfg.watermark_opacity, 10) || 18) / 100;

    if (cfg.watermark_style === 'tiled') {
      var bg = wmBackground();
      if (bg) w.style.backgroundImage = bg;
    } else {
      var span = document.createElement('span');
      span.textContent = cfg.watermark_text || '';
      span.style.fontSize = (parseInt(cfg.watermark_size, 10) || 16) + 'px';
      span.style.color = cfg.watermark_color || '#ffffff';
      w.appendChild(span);
    }

    host.appendChild(w);
  }

  /* ------------------------------------------------------------------ applier */

  function apply() {
    if (cfg.protect_video) {
      document.querySelectorAll('video').forEach(hardenVideo);
    }
    if (cfg.shield_gallery) {
      document.querySelectorAll(SHIELD_HOSTS).forEach(shield);
    }
    if (cfg.css_watermark) {
      document.querySelectorAll(SHIELD_HOSTS).forEach(watermark);
    }
  }

  function boot() {
    apply();

    // Dawn swaps gallery media, infinite scroll appends cards, the video widget
    // injects a player — all after first paint.
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        apply();
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
